export const SNAPPEA_TOKEN = 'snappea';
export const USER_ID = 'user_id';
export const USER_EMAIL = 'user_email';
export const VENDORS = 'vendors';

const url = new URL(`${import.meta.env.VITE_MY_FOODA_APP_URL}/provider_logout`);
url.searchParams.append('return_to', `${window.location.origin}/logout`);
export const LOGOUT_URL = url.href;
